import { useRegisterPageChrome, type EditMenuBypass } from '@/contexts/PageChromeContext';
import { cn } from '@/lib/utils';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export interface BreadcrumbItemData {
  label: string;
  href?: string;
  isActive?: boolean;
}

interface PageLayoutProps {
  breadcrumbItems: BreadcrumbItemData[];
  actions?: React.ReactNode;
  editMenuExtension?: React.ReactNode;
  editMenuBypass?: EditMenuBypass | null;
  children: React.ReactNode;
  className?: string;
  fullBleed?: boolean;
}

/**
 * Registers page breadcrumbs, actions, and edit-menu extensions with the global
 * header chrome and lays out the page body below.
 */
export const PageLayout = ({
  breadcrumbItems,
  actions,
  editMenuExtension,
  editMenuBypass,
  children,
  className,
  fullBleed = false,
}: PageLayoutProps) => {
  const location = useLocation();
  const chromeKey = location.pathname;

  const breadcrumbRegistration = useMemo(
    () => ({
      items: breadcrumbItems,
    }),
    [breadcrumbItems]
  );

  useRegisterPageChrome({
    key: chromeKey,
    breadcrumb: breadcrumbRegistration,
    actions,
    editMenuExtension,
    editMenuBypass,
    surface: fullBleed ? 'flush' : 'card',
  });

  return (
    <div
      className={cn(
        'flex w-full flex-col gap-5',
        fullBleed ? 'max-w-none' : 'mx-auto max-w-6xl',
        className
      )}
    >
      <div className='min-w-0'>{children}</div>
    </div>
  );
};
